/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Parameter } from './parameter';
import { S3PropertiesLocation } from './s3PropertiesLocation';


export interface JobDefinitionCreateRequest { 
    /**
     * The name of a valid namespace known by the system
     */
    namespace: string;
    /**
     * The name of the job definition
     */
    jobName: string;
    /**
     * An optional description of the job definition
     */
    description?: string;
    /**
     * Activiti workflow XML related to the job. Id should be named as \"{applicationName}.{jobName}\". Activiti XML can not contain a                   CDATA section                
     */
    activitiJobXml: string;
    /**
     * Default list of key/value pairs that will be made available to the job when it is executed. These values can be overridden by                   parameters                   specified during the job execution                
     */
    parameters?: Array<Parameter>;
    s3PropertiesLocation?: S3PropertiesLocation;
}
